import { render, staticRenderFns } from "./NoOrganisationPanel.vue?vue&type=template&id=23453982&"
import script from "./NoOrganisationPanel.vue?vue&type=script&lang=ts&"
export * from "./NoOrganisationPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports